import React from "react"
import NewsletterSignup from "@love-irish/newsletter-signup"

const NewsletterSection = () => {
  return (
    <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center justify-between">
      <div>
        <h3 className="text-2xl font-normal tracking-tight text-gray-900 sm:text-3xl font-fancy">
          Stay in the loop
        </h3>
        <p className="mt-3 text-lg text-gray-500 mb-6">
          Get new words to practice, interactive stories, reminders before every
          Celtic festival, and first word on new features straight to your
          inbox.
        </p>
      </div>
      <NewsletterSignup
        title="Get Irish in your inbox"
        source="footer"
        description="A little Irish in your inbox like new words, stories, and festival reminders. No spam."
      />
    </div>
  )
}

NewsletterSection.propTypes = {}

export default NewsletterSection
